import { render, staticRenderFns } from "./NewHeroLeft.vue?vue&type=template&id=8119cc46&scoped=true"
import script from "./NewHeroLeft.js?vue&type=script&lang=js&external"
export * from "./NewHeroLeft.js?vue&type=script&lang=js&external"
import style0 from "./NewHeroLeft.scss?vue&type=style&index=0&id=8119cc46&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8119cc46",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default,HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default,HotAppStoreButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/AppStoreButton/AppStoreButton.vue').default,HotLink: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Link/Link.vue').default})
